import { leaveCheckoutIfOrderIsCompleted, updateGlobalActivityIdHeader, updateGlobalShowingIdHeader } from 'src/modules/checkout/guards'

/**
 * @typedef {import('vue-router').RouteRecordRaw} RouteRecordRaw
 */

/**
 * Builds the child route objects for a checkout root parent route.
 *
 * We use a function to support dynamic generation and to ensure each parent route
 * has its own child routes that do not share references.
 * @returns {RouteRecordRaw[]}
 */
export function buildCheckoutChildRoutes (namespace = 'checkout') {
  return [
    {
      name: `${namespace}:showing`,
      path: 'showing/:id',
      component: () => import('src/modules/checkout/pages/Showing'),
      beforeEnter: updateGlobalShowingIdHeader
    },
    {
      name: `${namespace}:showing-slug`,
      path: 'showing/:slug/:id',
      meta: { canonical: true },
      component: () => import('src/modules/checkout/pages/Showing'),
      beforeEnter: updateGlobalShowingIdHeader
    },
    {
      name: `${namespace}:activity`,
      path: 'activity/:slug',
      meta: { canonical: true },
      component: () => import('src/modules/checkout/pages/ActivityCheckout'),
      beforeEnter: updateGlobalActivityIdHeader
    },
    {
      name: `${namespace}:activity-date-time`,
      path: 'activity/:slug/date-and-time',
      meta: { canonical: true },
      component: () => import('src/modules/checkout/pages/ActivityCheckout'),
      beforeEnter: updateGlobalActivityIdHeader
    },
    {
      name: `${namespace}:seats`,
      path: 'seats/:showingId?',
      component: () => import('src/modules/checkout/pages/Seats'),
      beforeEnter: [updateGlobalShowingIdHeader, leaveCheckoutIfOrderIsCompleted]
    },
    {
      name: `${namespace}:membership`,
      path: 'membership',
      component: () => import('src/modules/checkout/pages/membership/Membership'),
      beforeEnter: leaveCheckoutIfOrderIsCompleted
    },
    {
      name: `${namespace}:items`,
      path: 'items',
      component: () => import('src/modules/checkout/pages/Items'),
      beforeEnter: leaveCheckoutIfOrderIsCompleted
    },
    {
      name: `${namespace}:cart`,
      path: 'cart',
      component: () => import('src/modules/checkout/pages/CartPage'),
      beforeEnter: leaveCheckoutIfOrderIsCompleted
    },
    {
      name: `${namespace}:payment`,
      path: 'payment',
      component: () => import('src/modules/checkout/pages/Confirmation')
    },
    {
      name: `${namespace}:modify-membership`,
      path: 'modify-membership',
      component: () => import('src/modules/checkout/pages/ModifyMembership'),
      beforeEnter: leaveCheckoutIfOrderIsCompleted
    },
    {
      name: `${namespace}:more-films`,
      path: 'more-films',
      component: () => import('src/modules/checkout/pages/MoreFilms')
    },
    {
      name: `${namespace}:more-activities`,
      path: 'more-activities',
      component: () => import('src/modules/checkout/pages/MoreActivities')
    },
    {
      name: `${namespace}:ticket-package-options`,
      path: 'ticket-package-options',
      component: () => import('src/modules/checkout/pages/TicketPackageOptions')
    }
  ]
}
